import React, { memo, useContext } from 'react';
import {
    type NodeProps,
    type Node,
    Handle,
    Position,
} from '@xyflow/react';
import { Grid } from '@mui/material';
import IconsColor from '../../../utility/iconsColor';
import workFlowStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import { triggerDataTempObject } from '../flowBuilderConstants';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import globalStyles from '../../../../assets/styles/global.module.scss';
import { ChatbotStepDeploymentTriggerData } from '../../../../models/flowBuilderTypes';
import { primaryColor } from '../../../../utils/colors';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import clsx from 'clsx';
import { useIsCurrentActiveNode } from '../../../../hooks/useIsCurrentActiveNode';
import { CHATBOT_CHANNEL_STYLE_CLASS } from '../../../../utils/constants';
import { CHATBOT_CHANNEL_NAME, getChatbotChannelTheme } from '../../../../pages/ruleBasedInbox/channelConstants';
import { chatbotIntegratedChannelDeploymentInstagramObj, chatbotIntegratedChannelDeploymentObj } from '../../../../models/axiosModel';

const TriggerNode = ({ id, data }: NodeProps<Node<{ id: string, data: ChatbotStepDeploymentTriggerData }>>) => {

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const { setFlagOpenLeftPanel, setTriggerDataObject, setSelectedTrigger, setSelectedPointerEvent, setCurrentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const isCurrentActiveNode = useIsCurrentActiveNode(id);

    const whatsAppChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined;
    const instagramChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentInstagramObj | undefined;

    const deploymentChannelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const channelTheme = getChatbotChannelTheme(deploymentChannelName);

    const handleClickNewTriger = () => {
        setSelectedPointerEvent(triggerDataTempObject.function_name)
        setFlagOpenLeftPanel(true)
        setTriggerDataObject(triggerDataTempObject)
        setSelectedTrigger(triggerDataTempObject.function_triggers ? triggerDataTempObject?.function_triggers[0] : null)
    }

    const wp_deployment_data = [
        {
            key_name: "Deployment Channel",
            key_value: currentActiveStaticWorkflow?.chatbot_channel?.channel_name || "-"
        },
        {
            key_name: "Business Account",
            key_value: whatsAppChannel?.waba_name || "-"
        },
        {
            key_name: "Phone Number",
            key_value: whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number || "-"
        },
        {
            key_name: "Content Type",
            key_value: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.deployment_channel_content_type_data?.channel_content_type_name || "-"
        }, 
        {
            key_name: "Trigger Keywords", 
            key_value: currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_deployment_trigger_data?.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type.toLowerCase() == "static_value_check")?.condition_group?.condition_values || [],
        }
    ]

    // const fb_deployment_data = [
    //     {
    //         key_name: "Deploment Channel",
    //         key_value: currentActiveStaticWorkflow?.chatbot_channel?.channel_name || "-"
    //     },
    //     {
    //         key_name: "Page Name",
    //         key_value: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.[0]?.page_name || "-"
    //     },
    //     {
    //         key_name: "Page Category",
    //         key_value: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.[0]?.page_category || "-"
    //     },
    //     {
    //         key_name: "Content Type",
    //         key_value: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.[0]?.deployment_channel_content_type_data?.channel_content_type_name || "-"
    //     }
    // ]

    const ig_deployment_data = [
        {
            key_name: "Deployment Channel",
            key_value: currentActiveStaticWorkflow?.chatbot_channel?.channel_name || "-"
        },
        {
            key_name: "Business Account",
            key_value: instagramChannel?.instagram_account_name || "-"
        },
        {
            key_name: "Account ID",
            key_value: instagramChannel?.instagram_account_id || "-"
        },
        {
            key_name: "Content Type",
            key_value: currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.deployment_channel_content_type_data?.channel_content_type_name || "-"
        }, 
        {
            key_name: "Trigger Keywords", 
            key_value: currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_deployment_trigger_data?.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type.toLowerCase() == "static_value_check")?.condition_group?.condition_values || [],
        }
    ]

    const checkDeploymentData = (deployment_type: string) => {
        const dType = deployment_type.toLowerCase();
        switch (dType) {
            case CHATBOT_CHANNEL_NAME.WHATSAPP?.toLowerCase():
                return wp_deployment_data;
            case CHATBOT_CHANNEL_NAME.FACEBOOK?.toLowerCase():
                return wp_deployment_data;
            case CHATBOT_CHANNEL_NAME.INSTAGRAM?.toLowerCase():
                return ig_deployment_data;
            default:
                return wp_deployment_data;
        }
    }

    return (
        <Grid item
            // className={`${workFlowStyles.triggerCardGlobalStyle} ${workFlowStyles.relativePosition}`}
            className={clsx(
                workFlowStyles.triggerCardGlobalStyle,
                workFlowStyles.relativePosition,
                workFlowStyles[CHATBOT_CHANNEL_STYLE_CLASS.CHANNEL_THEMED],
                isCurrentActiveNode && workFlowStyles[CHATBOT_CHANNEL_STYLE_CLASS.ACTIVE_THEMED]
            )}
            style={{
                ["--channel-color" as any]: channelTheme.color,
                ["--channel-glow-color" as any]: channelTheme.glowColor,
            }}
            onClick={(e) => {
                e.stopPropagation(); // Prevents click from reaching parent
                setCurrentActiveNodeConfig((prevstate: any) => ({
                    ...prevstate,
                    flagOpenConfigForm: true,
                    nodeId: id,
                    data: data,
                    flag_trigger: true,
                    flag_initial: false
                }));
            }}
        >
            <Grid container direction="column" gap="18px">
                <Grid item>
                    <Grid container gap="12px" alignItems={"center"}>
                        <Grid item className={globalStyles.displayFlexStyle}>
                            <IconsColor width="20" height="20" iconName="trigger" />
                        </Grid>
                        <Grid item className={workFlowStyles.triggerCardHeadingStyle}>
                            When...
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={workFlowStyles.triggerCardSubHeadingStyle}>
                    <Grid container gap="2px" direction={"column"}>
                        <Grid item>
                            Automation is initiated by a trigger event.
                        </Grid>
                        <Grid item>
                            Click to set it up.
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={workFlowStyles.deploymentDataStyles}>
                    <Grid container direction={"column"} gap={2}>
                        <Grid item className={`${workFlowStyles.triggerCardHeadingStyle} ${globalStyles.fullwidth}`}>
                            Deployment Information
                        </Grid>
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"4px"}>
                                {checkDeploymentData(currentActiveStaticWorkflow?.chatbot_channel?.channel_name || "")?.map((dData) =>
                                    <Grid item className={globalStyles.fullwidth}>
                                        <Grid container gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                            <Grid item xs={10} className={workFlowStyles.deploymentKeyStyle}>{`${dData.key_name} : `}</Grid> 
                                            {dData.key_name?.toLowerCase() == "trigger keywords" ? 
                                                <Grid container gap={"5px"} flexWrap={"wrap"}>
                                                    {(Array.isArray(dData.key_value) && dData.key_value?.length > 0) ? dData.key_value.map((value) => {
                                                        return (
                                                            <Grid item className={`${workFlowStyles.deploymentValueStyle} ${workFlowStyles.triggerValueChip}`}>
                                                                {value}
                                                            </Grid>
                                                        )
                                                    })
                                                    : 
                                                        <Grid item xs={12} className={workFlowStyles.deploymentValueStyle}>-</Grid>
                                                    }
                                                </Grid>
                                                :
                                                <Grid item xs={12} className={workFlowStyles.deploymentValueStyle}>{dData.key_value}</Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={workFlowStyles.triggerButtonStyle} onClick={() => handleClickNewTriger()}>
                    <Grid container gap={"10px"} alignItems={"center"} justifyContent={"center"} flexWrap={"nowrap"}>
                        <Grid item display={"flex"}>
                            <IconsColor iconName="plus" width="13" height="13" fillColor={primaryColor} />
                        </Grid>
                        <Grid item>
                            New Trigger
                        </Grid>
                        <Grid item className={workFlowStyles.nodeWrapperSourceHandle}>
                            <Handle 
                                type="source" 
                                position={Position.Right} 
                                id={id}
                                isConnectable={!isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={`${workFlowStyles.triggerCardSubHeadingStyle} ${globalStyles.primaryFontWeight}`} textAlign={"end"} >
                    Then
                </Grid>
            </Grid>
        </Grid>

    );
};

export default memo(TriggerNode);